module.exports = __webpack_public_path__ + "static/media/mv.1fc44150.jpg";